module.exports = __webpack_public_path__ + "static/media/camera_view_top.e7e28807.svg";